import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=4c315453&scoped=true"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c315453",
  null
  
)

export default component.exports